/**
 * Универсальный кэш для фронтенда с сохранением в localStorage.
 * Позволяет мгновенно восстанавливать данные при Ctrl+Shift+R.
 */

const CACHE_PREFIX = 'neuralspace_cache_'
const DEFAULT_TTL_MS = 5 * 60 * 1000 // 5 минут

interface CacheEntry<T> {
  data: T
  timestamp: number
  ttl: number
}

export function getCached<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(CACHE_PREFIX + key)
    if (!raw) return null
    const entry: CacheEntry<T> = JSON.parse(raw)
    if (Date.now() - entry.timestamp > entry.ttl) {
      localStorage.removeItem(CACHE_PREFIX + key)
      return null
    }
    return entry.data
  } catch {
    return null
  }
}

export function setCache<T>(key: string, data: T, ttl: number = DEFAULT_TTL_MS): void {
  try {
    const entry: CacheEntry<T> = { data, timestamp: Date.now(), ttl }
    localStorage.setItem(CACHE_PREFIX + key, JSON.stringify(entry))
  } catch {
    // localStorage переполнен — чистим старые записи
    cleanupCache()
  }
}

export function clearCacheKey(key: string): void {
  localStorage.removeItem(CACHE_PREFIX + key)
}

export function clearAllCache(): void {
  const keys: string[] = []
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i)
    if (k?.startsWith(CACHE_PREFIX)) keys.push(k)
  }
  keys.forEach(k => localStorage.removeItem(k))
}

function cleanupCache(): void {
  // Удаляем самые старые записи до освобождения места
  const entries: { key: string; timestamp: number }[] = []
  for (let i = 0; i < localStorage.length; i++) {
    const k = localStorage.key(i)
    if (k?.startsWith(CACHE_PREFIX)) {
      try {
        const entry = JSON.parse(localStorage.getItem(k) || '{}')
        if (entry.timestamp) {
          entries.push({ key: k, timestamp: entry.timestamp })
        }
      } catch {}
    }
  }
  entries.sort((a, b) => a.timestamp - b.timestamp)
  // Удаляем 20% самых старых
  const removeCount = Math.ceil(entries.length * 0.2)
  for (let i = 0; i < removeCount; i++) {
    localStorage.removeItem(entries[i].key)
  }
}
